<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import BiddingDashboard from "@/router/views/procurement/bidding/dashboard.vue";
import BiddingRfq from "@/router/views/procurement/bidding/rfq.vue"
import RfqModal from "@/components/modals/rfq-modal.vue"
import { cloneDeep } from "lodash";
export default {
    page: {
        title: "Bidding",
    },
    components: {
        Layout,
        PageHeader,
        BiddingDashboard,
        BiddingRfq,
        RfqModal
    },
    data() {
        return {
            title: "Bidding",
            submitted: false,
            items: [
                {
                    text: "Dashboards",
                    href: "/",
                },
                {
                    text: "Bidding",
                    active: true,
                },
            ],
            bidActivities: [],
            dashboardData: [],
            rfqs: [],
            viewAs: localStorage.getItem('dBV') ? localStorage.getItem('dBV') : 'tiles',
            rfqType: 'submitted',
            filter: null,
            perPage: 10,
            pageOptions: [10, 25, 50, 100, 'All'],
            dashboardLoading: false,
            rfqLoading: false,
            publicPostLabels: [],
            units: [],
            shortenBidActivities: [],
            modalTitle: '',
            selectedPR: null,
            showCB: false,
            menuOpt: 2,
            selection: false,
        }
    },
    async created(){
        this.dashboardLoading = true;
        this.rfqLoading = true;
        await this.getBidActivity();
        await this.changeData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.dashboardLoading = false;
        this.getPublicPostLabels();
        this.getUnits()
        if(!localStorage.getItem('dBV')){
            localStorage.setItem('dBV', 'tiles');
        }
    },
    computed: {
        selectedPRs(){
            return this.rfqs.filter(x => x.selected);
        }
    },
    methods: {
        async changeData(cycle, campusId){
            this.rfqType = 'posted';
            this.menuOpt = 2;
            await this.getRfqs(cycle, campusId, this.rfqType)
        },
        async getBidActivity(){
            await this.$store
                .dispatch("bidactivity/GetAllBidActivity")
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    let short = [];
                    res.data.map(item => {
                        short.push({
                            id: item.id,
                            activityName: item.activityName
                        })
                    })
                    this.origBidActs = cloneDeep(res.data);
                    this.bidActivities = res.data.sort((a, b) => a.sort - b.sort);
                    this.shortenBidActivities = short;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getPublicBidding(cycle, campusId){
            await this.$store
                .dispatch("pr/GetPublicBidding", {cycle, campusId})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    res.data.map(item => {
                        item.prItems = [];
                        item.prItemLoading = false;
                        item.searchItem = '';
                        item.expand = false;
                        item.selected = false;
                        item.searchKey = `${item.prNumber} ${item.description}`;
                    })
                    // this.dashboardData = res.data;
                    this.rfqs = res.data;
                })
                .catch((err) => {
                    this.availableBusy = false;
                    this.showToast(
                        "Something went wrong - getting available items",
                        "error"
                    );
                });
        },
        async getRfqs(cycle, campusId, type){
            this.rfqLoading = true;
            if(type == 'submitted'){
                await this.getPublicBidding(cycle, campusId);
            }else if(type == 'posted'){
                await this.getSubmittedRfqs(cycle, campusId);
            }else{
                await this.getPostedRfqs(cycle, campusId);
            }
            this.rfqLoading = false;
        },
        async getSubmittedRfqs(cycle, campusId){
            await this.$store
                .dispatch("publicbidding/GetSubmitted", {cycle, campusId})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    res.data.map(item => {
                        item.searchKey = `${item.description} ${item.prNumber} ${item.rfqNumber}`;
                        item.itemLoading = false;
                        item.visible = false;
                        item.itemVisible = false;
                        item.addSupplier = false;
                        item.generatePO = false;
                        item.loadingPoNumber = false;
                        item.generatingPO = false;
                        item.supplierMessage = "";
                        item.supplierMsgType = "";
                        item.itemMessage = "";
                        item.itemMsgType = "";
                        item.isPosting = false;
                        item.postingMessage = "";
                        item.errorPost = false;
                        item.migrationItems = [];
                        item.bacApproved = false;

                        item.rfqFiles = [];
                        item.fileSearch = "";
                        item.attachmentLoading = true;
                        item.addDocu = false;
                        item.postLoading = false;
                        item.posts = [];

                        item.detailsLoaded = false;
                        item.rfqItems = [];
                        item.rfqBacSettings = [];
                        item.rfqSuppliers = [];
                        item.bacLoading = false;
                        item.rfqItemLoading = false;
                        item.selectItems = false;
                        item.forReAward = false;
                        item.forRecanvas = false;
                        item.selectAll = false;
                        item.poExist = true;

                        item.activityLoading = false;
                        item.rfqActivities = [];
                        item.searchItem = "";
                        item.reAward = false;
                        item.supCategory = 1;
                        item.invitedSuppliers = [];
                        item.activities = [];
                        item.prItems = [];
                        item.expand = false;
                    })
                    this.rfqs = res.data;
                })
                .catch((err) => {
                    this.showToast("Something went wrong - getting available items", "error");
                });
        },
        async getPostedRfqs(cycle, campusId){
            await this.$store
                .dispatch("publicbidding/GetPosted", {cycle, campusId})
                .then((res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, 'error');
                    }
                    res.data.map(item => {
                        item.searchKey = `${item.description} ${item.prNumber} ${item.rfqNumber}`;
                        item.itemLoading = false;
                        item.visible = false;
                        item.itemVisible = false;
                        item.addSupplier = false;
                        item.generatePO = false;
                        item.loadingPoNumber = false;
                        item.generatingPO = false;
                        item.supplierMessage = "";
                        item.supplierMsgType = "";
                        item.itemMessage = "";
                        item.itemMsgType = "";
                        item.isPosting = false;
                        item.postingMessage = "";
                        item.errorPost = false;
                        item.migrationItems = [];
                        item.bacApproved = false;

                        item.rfqFiles = [];
                        item.fileSearch = "";
                        item.attachmentLoading = true;
                        item.addDocu = false;
                        item.postLoading = false;
                        item.posts = [];

                        item.detailsLoaded = false;
                        item.rfqItems = [];
                        item.rfqBacSettings = [];
                        item.rfqSuppliers = [];
                        item.bacLoading = false;
                        item.rfqItemLoading = false;
                        item.selectItems = false;
                        item.forReAward = false;
                        item.forRecanvas = false;
                        item.selectAll = false;
                        item.poExist = true;

                        item.activityLoading = false;
                        item.rfqActivities = [];
                        item.searchItem = "";
                        item.reAward = false;
                        item.supCategory = 2;
                        item.invitedSuppliers = [];
                        item.activities = [];
                        item.prItems = [];
                        item.expand = false;
                    })
                    this.rfqs = res.data;
                })
                .catch((err) => {
                    this.showToast(
                        "Something went wrong - getting available items",
                        "error"
                    );
                });
        },
        async getPublicPostLabels(){
            await this.$store.dispatch('postingfilelabel/GetAllPFL')
                .then(res => {
                    this.publicPostLabels = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
        },
        async getUnits() {
            await this.$store
                .dispatch("unit/GetUnit")
                .then((res) => this.units = res.data)
                .catch(() =>  this.showToast("Something went wrong - getting units", "error"));
        },
        mergeAndCreate(){
            if(this.selectedPRs.length < 2){
                return this.showToast('Select at least two (2) Purchase Requests to merge.', 'warning');
            }
            this.$refs.rfqModal.updateData({
                id: 0,
                prIds: this.selectedPRs.map(pr => pr.id),
                description: this.selectedPRs[0].description,
                tracking: null,
                deadline: null,
                note: null,
                dateSubmitted: null,
                bidDocsAvailableDate: null,
                bidOpeningDate: null,
                bidDocsAmount: null,
                bidSecurityValidUntil: null,
                slccPercentageRequired: null,
            })
            this.modalTitle = 'Create Merged Bid For Sale';
            this.$bvModal.show('create-rfq');
        },
        createRfq(pr){
            this.selectedPR = pr;
            this.$refs.rfqModal.updateData({
                id: 0,
                prIds: [pr.id],
                description: pr.description,
                tracking: null,
                deadline: null,
                note: null,
                dateSubmitted: null,
                bidDocsAvailableDate: null,
                bidOpeningDate: null,
                bidDocsAmount: null,
                bidSecurityValidUntil: null,
                slccPercentageRequired: null,
            })
            this.modalTitle = 'Create Bid For Sale';
            this.$bvModal.show('create-rfq');
        },
        async saveRfq(modalData){
            if(modalData.id > 0){
                await this.$store
                .dispatch("publicbidding/UpdatePB", modalData)
                .then(async (res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    let index = this.rfqs.findIndex(x => x.id == modalData.id);
                    this.rfqs.splice(index, 1, modalData);
                    this.$bvModal.hide('create-rfq');
                    this.showToast("Bidding Details Successfully Saved!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong! - saving rfq", "error");
                });
            }else{
                await this.$store
                .dispatch("publicbidding/GenerateRfq", modalData)
                .then(async (res) => {
                    if(res.data.error){
                        return this.showToast(res.data.errorMessage, "error");
                    }
                    modalData.prIds.map(id => {
                        let index = this.rfqs.findIndex(x => x.id == id);
                        this.rfqs.splice(index, 1);
                    })
                    this.$bvModal.hide('create-rfq');
                    this.showToast("Bidding Details Successfully Saved!", "success");
                })
                .catch((err) => {
                    this.showToast("Something went wrong! - saving rfq", "error");
                });
            }
        },
        changeView(view){
            this.viewAs = view;
            if(localStorage.getItem('dBV') == view){
                this.showCB = false;
            }else{
                this.showCB = true;
            }
        },
        changeDefaultView($ev){
            if($ev.srcElement.checked){
                localStorage.setItem('dBV', this.viewAs);
            }
            this.showCB = false;
        },
        updateBid(data){
            this.selectedPR = data;
            this.$refs.rfqModal.updateData(data);
            this.modalTitle = 'Update Bid For Sale';
            this.$bvModal.show('create-rfq');
        },
        showOpt(){
            let el = document.getElementById('bid-opt');
            this.selection = true;
            if(el.style.display == 'block'){
                el.style.display = 'none';
            }else{
                el.style.display = 'flex';
            }
        },
        selectOpt(opt){
            if(this.menuOpt == opt){
                this.selection = false;
                let el = document.getElementById('bid-opt');
                el.style.display = 'none';
                return;
            }
            this.menuOpt = opt;
            this.selection = false;
            let el = document.getElementById('bid-opt');
            el.style.display = 'none';
            if(opt == 1){
                this.rfqType = 'submitted';
                this.viewAs = 'tiles';
                this.getRfqs(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id, this.rfqType);
            }else if(opt == 2){
                this.rfqType = 'posted';
                this.viewAs = 'tiles';
                this.getRfqs(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id, this.rfqType);
            }else{
                this.rfqType = 'processed';
                this.viewAs = 'tiles';
                this.getRfqs(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id, this.rfqType);
            }
        },
        dropBG(){
            this.selection = false;
            let el = document.getElementById('bid-opt');
            if(el) el.style.display = 'none';
        }
    }
}
</script>

<template>
    <Layout @changeCycle="changeData($event, $store.state.data.selectedCampus.id)" @changeCampus="changeData($store.state.data.cycle, $event.id)">
        <PageHeader :title="title" :items="items" />
        
        <div class="mb-2 d-flex justify-content-between align-items-center">
            <div class="d-flex w-75">
                <input type="text" class="form-control w-25" placeholder="Search Project..." v-model="filter"/>
                <b-form-select
                    style="width:80px;"
                    class="form-select form-select-sm ms-1"
                    v-model="perPage"
                    :options="pageOptions"
                />
                <div 
                    class="border border-2 ms-1 rounded position-relative"
                    style="z-index: 100;" 
                    :class="{
                        'border-warning': menuOpt == 1, 
                        'border-success': menuOpt == 2,
                        'border-info': menuOpt == 3
                    }"
                >
                    <b-button 
                        variant="white" 
                        class=" text-white" 
                        @click="showOpt"
                    >
                        {{ menuOpt == 1 ? 'Available Purchase Request for Bidding' : (menuOpt == 2 ? 'On Process Bidding' : 'Processed Bidding') }}
                    </b-button>
                    <div class="bid-opt" id="bid-opt">
                        <div 
                            class="cursor-pointer p-2 bid-child" 
                            :class="{'bg-warning text-white': menuOpt == 1}" 
                            @click="selectOpt(1)"
                        >
                            <i class='bx bx-receipt'></i> Available Purchase Request for Bidding
                        </div>
                        <div 
                            class="cursor-pointer p-2 bid-child" 
                            :class="{'bg-success text-white': menuOpt == 2}" 
                            @click="selectOpt(2)"
                        >
                            <i class='bx bx-hourglass'></i> On Process Bidding
                        </div>
                        <div 
                            class="cursor-pointer p-2 bid-child" 
                            :class="{'bg-info text-white': menuOpt == 3}" 
                            @click="selectOpt(3)"
                        >
                            <i class='bx bx-check'></i> Processed Bidding
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="menuOpt == 1 && selectedPRs.length" class="text-secondary">
                <button class="btn btn-success" @click="mergeAndCreate"><i class="mdi mdi-arrow-collapse"></i> Merge and Create Bid for Sale</button>
            </div>
            <div class="d-flex w-25 h-100 flex-row-reverse align-items-center" v-if="menuOpt != 1">
                <div class="d-flex rd-edges">
                    <div 
                        class="border d-flex align-items-center py-1 px-2 cursor-pointer" 
                        :class="{'text-purple border-primary': viewAs == 'tiles'}"
                        @click="changeView('tiles')"
                    >
                        <i class="bx bx-layout line-height-1 font-size-24"></i>
                    </div>
                    <div 
                        class="border d-flex align-items-center py-1 px-2 cursor-pointer" 
                        :class="{'text-purple border-primary': viewAs == 'list'}"
                        @click="changeView('list')"
                    >
                        <i class="bx bx-list-ul line-height-1 font-size-24"></i>
                    </div>
                </div>
                <div
                    class="
                        form-check
                        form-checkbox-outline
                        form-check-success
                        mb-0 me-3
                    "
                    v-if="showCB"
                >
                    <input
                        type="checkbox"
                        :id="`default-view`"
                        class="form-check-input"
                        @change="changeDefaultView"
                    /><label
                        :for="`default-view`"
                        class="form-check-label"
                    >
                        Set as Default View?
                    </label>
                </div>
            </div>
        </div>
        <template>
            <template v-if="viewAs == 'tiles'">
                <BiddingRfq 
                    :menuOpt="menuOpt"
                    :loading="rfqLoading"
                    :rfqData="rfqs"
                    :filter="filter"
                    :perPage="perPage"
                    :publicPostLabels="publicPostLabels"
                    :rfqType="rfqType"
                    :units="units"
                    :bidActivities="shortenBidActivities"
                    :selectedPRs="selectedPRs"
                    @createRfq="createRfq"
                    @updateBid="updateBid"
                />
            </template>
            <template v-else>
                <BiddingDashboard 
                    :loading="dashboardLoading"
                    :headers="bidActivities"
                    :rfqs="rfqs"
                    :filter="filter"
                    :perPage="perPage"
                    @createRfq="createRfq"
                />
            </template>
        </template>
        <RfqModal 
            ref="rfqModal"
            :modalTitle="modalTitle"
            @saveRfq="saveRfq"
        />
        <div class="position-fixed selection-bg" v-if="selection" @click="dropBG"></div>
    </Layout>
</template>
<style lang="scss">
.bid-opt{
    display: none;
    position: absolute;
    right: -310px;
    top: 50%;
    transform: translateY(-50%);
    width: 300px;
    flex-direction: column;
    gap: 10px;
    height: 100px;
    .bid-child{
        border-radius: 25px;
        border: 1px solid var(--bs-gray-300);
        text-align: center;
        background: var(--bs-body-bg);
        &:first-child{
            color: var(--bs-warning);
            position: absolute;
            top: -15px;
            left: -70px;
            width: 100%;
        }
        &:nth-child(2){
            color: var(--bs-success);
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 0;
            width: 100%;
        }
        &:last-child{
            color: var(--bs-info);
            position: absolute;
            bottom: -15px;
            left: -70px;
            width: 100%;
        }
    }
}
.selection-bg{
    inset: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0,0,0,0.2);
    z-index: 99;
    backdrop-filter: blur(4px);
}
</style>